import { render } from "./MenuCreationGroups-edit.vue?vue&type=template&id=b2a0be54"
import script from "./MenuCreationGroups-edit.vue?vue&type=script&lang=js"
export * from "./MenuCreationGroups-edit.vue?vue&type=script&lang=js"

import "./MenuCreationGroups-edit.vue?vue&type=style&index=0&id=b2a0be54&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__